import React from "react";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { useSelector, useDispatch } from "react-redux";
import { clearSnackbar } from "../../store/actions/Snackbar";
import { injectIntl } from "react-intl";
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export function SnackbarMaterial() {
  const {
    successSnackbarMessage,
    successSnackbarOpen,
    snacknarType,
  } = useSelector((state) => state.snackbar);
  const dispatch = useDispatch();
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch(clearSnackbar());
  };
  const renderMsg = () => {
    return (
      <>
        {typeof successSnackbarMessage === "string"
          ? successSnackbarMessage
          : successSnackbarMessage.map((elt) => {
              return <p>{elt}</p>;
            })}
      </>
    );
  };
  return (
    <Snackbar
      open={successSnackbarOpen}
      autoHideDuration={6000}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      key={`bottom,center`}
      onClose={() => dispatch(clearSnackbar())}
    >
      <Alert
        onClose={handleClose}
        severity={snacknarType}
        className="medium_font"
      >
        {successSnackbarMessage && renderMsg()}
      </Alert>
    </Snackbar>
  );
}

export const SnackbarComponent = injectIntl(SnackbarMaterial);
